/*
  <stelbo-rail> — sagetile, bara de progres, bucla si autoplay-ul railului.

  Gestul de swipe NU e aici: railul e un container cu overflow-x si
  scroll-snap, deci degetul il muta browserul, cu momentum nativ. JS-ul
  adauga doar ce nu poate face CSS-ul singur.

  Bucla: clonam primul si ultimul ecran de carduri la capete, apoi cand
  scrollul ajunge in zona clonata sarim inapoi cu scrollLeft (fara
  `behavior: smooth`, deci saltul e invizibil).
*/
(function () {
  if (customElements.get('stelbo-rail')) return;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  class StelboRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-st-track]');
      if (!this.track) return;

      this.bar = this.querySelector('[data-st-progress-bar]');
      var inner = this.closest('.st-bs__inner');
      this.nav = inner ? inner.querySelector('[data-st-nav]') : null;

      this.slides = Array.prototype.slice.call(
        this.track.querySelectorAll('[data-st-slide]')
      );
      if (this.slides.length < 2) return;

      this.realCount = this.slides.length;
      this.looping = this.dataset.loop === 'true';
      if (this.looping) this._buildClones();

      this._bindNav();
      this._bindScroll();
      this._bindAutoplay();

      // Prima masuratoare dupa ce imaginile si-au rezervat spatiul.
      requestAnimationFrame(this._sync.bind(this));
      this._onResize = this._debounce(this._sync.bind(this), 150);
      window.addEventListener('resize', this._onResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._onResize);
      this._stopAutoplay();
      if (this.io) this.io.disconnect();
    }

    /* ---- bucla ---------------------------------------------------------- */

    _buildClones() {
      var perView = Math.max(1, Math.round(this._trackWidth() / this._step()));
      var n = Math.min(perView + 1, this.realCount);
      var frag = document.createDocumentFragment();
      var i, node;

      for (i = 0; i < n; i++) {
        node = this.slides[i].cloneNode(true);
        node.setAttribute('aria-hidden', 'true');
        node.dataset.clone = 'tail';
        this._deactivate(node);
        frag.appendChild(node);
      }
      this.track.appendChild(frag);

      frag = document.createDocumentFragment();
      for (i = this.realCount - n; i < this.realCount; i++) {
        node = this.slides[i].cloneNode(true);
        node.setAttribute('aria-hidden', 'true');
        node.dataset.clone = 'head';
        this._deactivate(node);
        frag.appendChild(node);
      }
      this.track.insertBefore(frag, this.track.firstChild);

      this.leadIn = n;
      // Pornim dupa clonele de la inceput, fara animatie.
      this.track.scrollLeft = this._step() * n;
    }

    /* Clonele nu trebuie sa fie focusabile: ar dubla ordinea de tabulare. */
    _deactivate(node) {
      var kids = node.querySelectorAll('a, button, input, select, textarea');
      Array.prototype.forEach.call(kids, function (el) {
        el.setAttribute('tabindex', '-1');
        el.setAttribute('aria-hidden', 'true');
      });
    }

    _wrap() {
      if (!this.looping) return;
      var step = this._step();
      var lead = this.leadIn * step;
      var span = this.realCount * step;
      var x = this.track.scrollLeft;

      if (x < lead - step * 0.5) {
        this.track.scrollLeft = x + span;
      } else if (x >= lead + span - step * 0.5) {
        this.track.scrollLeft = x - span;
      }
    }

    /* ---- masuratori ----------------------------------------------------- */

    _trackWidth() {
      return this.track.clientWidth;
    }

    _step() {
      var first = this.track.querySelector('[data-st-slide]');
      if (!first) return this._trackWidth();
      var styles = window.getComputedStyle(this.track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    }

    /* ---- sageti --------------------------------------------------------- */

    _bindNav() {
      if (!this.nav) return;
      var self = this;
      var prev = this.nav.querySelector('[data-st-prev]');
      var next = this.nav.querySelector('[data-st-next]');

      if (prev) prev.addEventListener('click', function () { self._move(-1); });
      if (next) next.addEventListener('click', function () { self._move(1); });

      this.track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); self._move(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); self._move(-1); }
      });
    }

    _move(dir) {
      this._pauseAutoplay();
      this.track.scrollBy({
        left: this._step() * dir,
        behavior: REDUCED.matches ? 'auto' : 'smooth'
      });
    }

    /* ---- progres si stari ----------------------------------------------- */

    _bindScroll() {
      var self = this;
      var ticking = false;
      this.track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          self._wrap();
          self._sync();
          ticking = false;
        });
      }, { passive: true });
    }

    _sync() {
      var max = this.track.scrollWidth - this.track.clientWidth;
      var overflows = max > 1;

      if (this.nav) this.nav.hidden = !overflows;

      if (this.bar) {
        var ratio = this.track.clientWidth / (this.track.scrollWidth || 1);
        var pos = max > 0 ? this.track.scrollLeft / max : 0;
        var thumb = ratio * 100;
        this.bar.style.setProperty('--st-bs-thumb', thumb + '%');
        this.bar.style.setProperty('--st-bs-pos', pos * (100 - thumb) + '%');
      }

      if (!this.looping && this.nav) {
        var prev = this.nav.querySelector('[data-st-prev]');
        var next = this.nav.querySelector('[data-st-next]');
        if (prev) prev.disabled = this.track.scrollLeft <= 1;
        if (next) next.disabled = this.track.scrollLeft >= max - 1;
      }
    }

    /* ---- autoplay ------------------------------------------------------- */

    _bindAutoplay() {
      var secs = parseFloat(this.dataset.autoplay || '0');
      if (!secs || REDUCED.matches) return;
      this.interval = secs * 1000;

      var self = this;
      ['pointerenter', 'focusin'].forEach(function (ev) {
        self.addEventListener(ev, function () { self._stopAutoplay(); });
      });
      ['pointerleave', 'focusout'].forEach(function (ev) {
        self.addEventListener(ev, function () { self._startAutoplay(); });
      });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { self._stopAutoplay(); } else { self._startAutoplay(); }
      });

      // Porneste doar cat timp sectiunea e pe ecran.
      this.io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { self._startAutoplay(); }
        else { self._stopAutoplay(); }
      }, { threshold: 0.25 });
      this.io.observe(this);
    }

    _startAutoplay() {
      if (!this.interval || this.timer) return;
      var self = this;
      this.timer = setInterval(function () { self._move(1); }, this.interval);
    }

    _stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    /* Dupa o interactiune manuala lasam 3 cicluri de liniste. */
    _pauseAutoplay() {
      if (!this.interval) return;
      this._stopAutoplay();
      var self = this;
      clearTimeout(this.resume);
      this.resume = setTimeout(function () { self._startAutoplay(); }, this.interval * 3);
    }

    _debounce(fn, wait) {
      var t;
      return function () {
        clearTimeout(t);
        t = setTimeout(fn, wait);
      };
    }
  }

  customElements.define('stelbo-rail', StelboRail);
})();
